/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    /**
     * 
     */
    name?: string;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit(value: object): value is IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    return true;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnitToJSONTyped(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedRoomBedUnit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

